import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/logo.png";
import cart from "../../assets/bytesize_cart.png";
import "../header/header.css";
import SlidingMenu from "../loginSlide/SlidingMenu";
import { signOut } from "@firebase/auth";
import { auth } from "../../firebase";
import { useState } from "react";
import { useAuth } from "../../auth/useAuth";
import CartCheckout from "../../components/checkout-cart/CartCheckout";

const Header = () => {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [toggleOtp, setToggleOtp] = useState(true);
  const { user } = useAuth();

  const [subTypesModal, setSubTypesModal] = useState(false);

  const handleClick = () => {
    console.log(toggleMenu);
    setToggleMenu(!toggleMenu);
    setToggleOtp(!toggleOtp);
    console.log(toggleOtp, "Togglrotp------------");
  };

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        alert("Logged out successfully!");
      })
      .catch(() => {
        alert("Error logging out!");
      });
  };

  return (
    <div>
      <div className="header_main">
        <header id="main_header">
          <div className="container-fluid">
            <nav className="navbar navbar-expand-lg navbar-light">
              <Link className="navbar-brand" href="#">
                <img className="img-fluid" src={logo} alt="img" />
              </Link>
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav ml-auto">
                  <li className="nav-item active">
                    <Link className="nav-link" to="/">
                      Home
                    </Link>
                    {/* <Link >Home</Link> */}
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/services">
                      Services
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/subscription">
                      Subscription
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/blogs">
                      Blog
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/aboutus">
                      About Us
                    </Link>
                  </li>
                  {/* <li className="nav-item">
                <Link className="nav-link" href="#">Login  </Link>
              </li> */}
                  {!user ? (
                    <span type="button" onClick={handleClick}>
                      Login
                      {/* <span className="glyphicon glyphicon-menu-hamburger">LOGIN</span> */}
                    </span>
                  ) : (
                    <span type="button" onClick={handleLogout}>
                      Sign out
                      {/* <span className="glyphicon glyphicon-menu-hamburger">LOGIN</span> */}
                    </span>
                  )}
                  {/* <li className="nav-item">
                <Link className="nav-link" href="#">Login  </Link>
              </li> */}
                  {/*  */}
                  <li
                    className="nav-item"
                    style={{
                      fontSize: "15px",
                      fontWeight: 500,
                      color: "#fff",
                      cursor: "pointer",
                    }}
                    onClick={() => setSubTypesModal(true)}
                  >
                    <span>
                      <img className="img-fluid" src={cart} alt="img" />
                    </span>
                  </li>
                </ul>
              </div>
            </nav>
          </div>
          <div className="main-container">
            {/* <button type="button" onClick={this.handleClick}>
          <span className="glyphicon glyphicon-menu-hamburger">LOGIN</span>
        </button> */}
            <SlidingMenu
              slideClass={
                toggleMenu ? "slideInLeft slide-menu" : "slideInRight"
              }
              onClick={handleClick}
            ></SlidingMenu>
          </div>
          <div>
            {/* CART CHECKOUT */}
            <CartCheckout
              subTypesModal={subTypesModal}
              setSubTypesModal={setSubTypesModal}
            />
          </div>
          {/* <div className={boxClass.join(' ')} onClick={this.toggle.bind(this)}>{this.state.addClass ? "Remove a class" : "Add a class (click the box)"} Open</div> */}
        </header>
      </div>
    </div>
  );
};

export default Header;
